module.exports = __webpack_public_path__ + "img/settingsWhite.69577b2b.gif";